/**
 * AdminOnlyRoute — allows access only to users with isAdmin: true.
 * Moderators are redirected to Item Management (their allowed area).
 */
import { useState, useEffect } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../hooks/useAuth";
import firestoreService from "../../services/firestoreService";
import LoadingSpinner from "./LoadingSpinner";
import { ROUTES } from "../../utils/constants";

const AdminOnlyRoute = ({ children }) => {
  const { isAuthenticated, loading, user } = useAuth();
  const [checking, setChecking] = useState(true);
  const [isAdmin, setIsAdmin] = useState(false);
  const [isModerator, setIsModerator] = useState(false);

  useEffect(() => {
    if (!isAuthenticated || !user?.email) {
      setChecking(false);
      return;
    }
    firestoreService
      .getUserAccount(user.email)
      .then((account) => {
        setIsAdmin(account?.isAdmin === true);
        setIsModerator(
          account?.isModerator === true && account?.isAdmin !== true,
        );
      })
      .catch(() => {})
      .finally(() => setChecking(false));
  }, [isAuthenticated, user?.email]);

  if (loading || checking) {
    return (
      <div className="protected-route-loading">
        <LoadingSpinner />
        <p>Checking permissions...</p>
      </div>
    );
  }

  if (!isAuthenticated) return <Navigate to={ROUTES.ADMIN_LOGIN} replace />;

  // Moderators get redirected to their own dashboard
  if (isModerator && !isAdmin)
    return <Navigate to={ROUTES.MODERATOR_DASHBOARD} replace />;

  // Neither admin nor moderator
  if (!isAdmin) return <Navigate to={ROUTES.ADMIN_LOGIN} replace />;

  return children;
};

export default AdminOnlyRoute;
